archive.classy.controller({
    name: 'ArchiveController',
    inject: ['$scope', 'BinFactory', 'ApplicationsSubNavbarService', 'ApplicationService'],
    init: function()
    {
    	this.$.ApplicationsSubNavbarService = this.ApplicationsSubNavbarService;
    	this.$.ApplicationService = this.ApplicationService;
    },
    toggleFilter: function() {
        this.resizeAppList(!this.$.masseditopen);
        this.$.masseditopen = !this.$.masseditopen;
    }
});


